// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2TIa_","amount":"Amount_amount__PDSzl","tip":"Amount_tip__3e0Th","tipHeader":"Amount_tipHeader__2Ys3q","tipsWrap":"Amount_tipsWrap__3pt8J"};